import http from "../_http_v2";

const group = {
  //default
  list: (m) => { return http.post(`console/management/group/list`, m); },
  detail: (m) => { return http.get(`console/management/group/${m.id}`); },

  //crud
  update: (m) => { return http.put(`console/management/group`, m); },
  delete: (m) => { return http.delete(`console/management/group/${m.id}`); },

  //report
  report: (m) => { return http.post(`console/management/group/report/`, m); },  //확인이 필요한 api 이며 현재 쓰이지않는것으로 판단되어짐
}

export default group